import { render, staticRenderFns } from "./UserImage.vue?vue&type=template&id=5b63ba28&scoped=true&functional=true&"
import script from "./UserImage.vue?vue&type=script&lang=js&"
export * from "./UserImage.vue?vue&type=script&lang=js&"
import style0 from "./UserImage.vue?vue&type=style&index=0&id=5b63ba28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5b63ba28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b63ba28')) {
      api.createRecord('5b63ba28', component.options)
    } else {
      api.rerender('5b63ba28', component.options)
    }
    module.hot.accept("./UserImage.vue?vue&type=template&id=5b63ba28&scoped=true&functional=true&", function () {
      api.rerender('5b63ba28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/User/UserImage.vue"
export default component.exports